import { AvariasTipoFerramenta } from './../../../models/avariatipoferramenta.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { align } from '@progress/kendo-drawing';

@Component({
  selector: 'app-avaria-type-form',
  templateUrl: './avaria-type-form.component.html',
  styleUrls: ['./avaria-type-form.component.scss']
})
export class AvariaTypeFormComponent implements OnInit {
  active: boolean = false;
  public customMsgService: CustomMessagesService = new CustomMessagesService;
  
  constructor(public msgService: MessageService) { 
    this.customMsgService = this.msgService as CustomMessagesService;
  }
  public maxlength = 20;
  public charachtersCount = 0;
  public counter = `${this.charachtersCount}/${this.maxlength}`;

  ngOnInit(): void {
  }
  public editForm: FormGroup = new FormGroup({
  
    pt: new FormControl("", Validators.required),
    en: new FormControl("", Validators.required),
    fr: new FormControl("", Validators.required),
    codigo: new FormControl("", Validators.required),
    observacao: new FormControl(""),
   
  });

  @Input() public isNew = false;

 // @Input() public isNew = false;

  @Input() public set model(product: AvariasTipoFerramenta) {
    this.editForm.reset(product);

    // toggle the Dialog visibility
    this.active = product !== undefined;
  }

  @Output() cancel: EventEmitter<undefined> = new EventEmitter();
  @Output() save: EventEmitter<AvariasTipoFerramenta> = new EventEmitter();

  public inputBlur()
    {
    
      var texto = this.editForm.controls['pt'].value;
      this.editForm.controls['en'].setValue(texto) ;
      this.editForm.controls['fr'].setValue(texto) ;
      
    
 }

  public onSave(e: PointerEvent): void {
    e.preventDefault();
    this.save.emit(this.editForm.value);
    this.active = false;
  }

  public onCancel(e: PointerEvent): void {
    e.preventDefault();
    this.closeForm();
  }

  public closeForm(): void {
    this.active = false;
    this.cancel.emit();
  }

  public onValueChange(ev: string): void {
    this.charachtersCount = ev.length;
    this.counter = `${this.charachtersCount}/${this.maxlength}`;
  }

}
